export var EnvObjType;
(function (EnvObjType) {
    EnvObjType["NUMBER"] = "NUMBER";
    EnvObjType["BOOLEAN"] = "BOOLEAN";
    EnvObjType["NULL"] = "NULL";
    EnvObjType["RETURN_VALUE"] = "RETURN_VALUE";
    EnvObjType["ERROR"] = "ERROR";
    EnvObjType["FUNCTION"] = "FUNCTION";
    EnvObjType["STRING"] = "STRING";
    EnvObjType["BUILTIN"] = "BUILTIN";
    EnvObjType["ARRAY"] = "ARRAY";
    EnvObjType["HASH"] = "HASH";
    EnvObjType["UNDEFINED"] = "UNDEFINED";
})(EnvObjType || (EnvObjType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib2JqLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2xpYi9lbnYvb2JqLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBTixJQUFZLFVBWVg7QUFaRCxXQUFZLFVBQVU7SUFDbEIsK0JBQWlCLENBQUE7SUFDakIsaUNBQW1CLENBQUE7SUFDbkIsMkJBQWEsQ0FBQTtJQUNiLDJDQUE2QixDQUFBO0lBQzdCLDZCQUFlLENBQUE7SUFDZixtQ0FBcUIsQ0FBQTtJQUNyQiwrQkFBaUIsQ0FBQTtJQUNqQixpQ0FBbUIsQ0FBQTtJQUNuQiw2QkFBZSxDQUFBO0lBQ2YsMkJBQWEsQ0FBQTtJQUNiLHFDQUF1QixDQUFBO0FBQzNCLENBQUMsRUFaVyxVQUFVLEtBQVYsVUFBVSxRQVlyQiJ9